import { eachDayOfInterval } from 'date-fns';
import { TimeIntervalTypeValues } from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';
import { getDailyPeriodStartFromEndDay } from 'src/components/oneCorp/features/MealCredit/utils/getDailyPeriodStartFromEndDay';

export interface GetMonthAvailableDaysCountProps {
  startDate: Date;
  monthAvailableTo: Date;
  timeIntervalType: TimeIntervalTypeValues;
}

export function getMonthAvailableDaysCount({
  startDate,
  monthAvailableTo,
  timeIntervalType,
}: GetMonthAvailableDaysCountProps): number {
  const end = getDailyPeriodStartFromEndDay(monthAvailableTo, timeIntervalType);

  return eachDayOfInterval({
    start: startDate,
    end,
  }).length;
}
